import React, { useRef } from "react";
import Icon from "@mui/material/Icon";
import { DeleteFile } from "../redux/api/upload.api";

function CustomImageUploader({ value, setFile, files, setImage, onRemove, canUpload = true }) {
  const fileInputRef = useRef(null);

  function handleImageChange(e) {
    const selectedImage = e.target.files[0];
    if (selectedImage) {
      setFile(selectedImage);
      setImage(URL.createObjectURL(selectedImage));
    }
  }

  const onClickRemove = async (file_id) => {
    const confirmation = window.confirm("Are you sure you want to delete it?");
    if (confirmation) {
      await DeleteFile(file_id);
      window.location.reload();
    }
  };

  const handleButtonClick = () => {
    fileInputRef?.current?.click();
  };

  return (
    <div style={{ padding: "1rem" }}>
      {/* Image Previews */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "1rem",
        }}
      >
        {/* Upload Button (hidden when canUpload is false) */}
        {canUpload && (
          <div
            style={{
              width: "calc(33.33% - 1rem)", // Matches the size of images
              aspectRatio: "1/1",
              borderWidth: 2,
              border: "2px dashed #d0d0d0",
              borderRadius: 8,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              color: "#d0d0d0",
            }}
            onClick={handleButtonClick}
          >
            <input
              type="file"
              accept="image/*"
              ref={fileInputRef}
              onChange={handleImageChange}
              style={{ display: "none" }}
            />
            +
          </div>
        )}

        {/* Images */}
        {files?.map((item, index) => (
          <div
            key={index}
            style={{
              position: "relative",
              width: "calc(33.33% - 1rem)", // Ensure three items per row
              aspectRatio: "1/1", // Maintain square ratio
              borderRadius: 8,
              overflow: "hidden", // Ensures image doesn't overflow the border radius
            }}
          >
            {/* Image */}
            <img
              src={item?.url}
              alt={`Preview ${index}`}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />

            {/* Trash Icon */}
            <button
              onClick={() => onClickRemove(item?.id)}
              style={{
                position: "absolute",
                top: "8px",
                right: "8px",
                backgroundColor: "rgba(0, 0, 0, 0.6)",
                color: "#fff",
                border: "none",
                borderRadius: "50%",
                width: "24px",
                height: "24px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <Icon style={{ color: "red", fontSize: "20px" }}>delete</Icon>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CustomImageUploader;
